<template>
	<div class="single-page-wrap">
		<!-- <div ref="form" class="weui-form__control-area"> -->
		<!-- <div class="weui-cells__group weui-cells__group_form"> -->
		<!-- <div class="weui-cells weui-cells_form"> -->
		<!-- <div class="weui-cell weui-cell_active">
						<div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
						<div class="weui-cell__bd">
							<input class="weui-input" v-model="phonenumber" type="tel" maxlength="11"
								   required emptyTips="请输入手机号" placeholder="请输入手机号"/>
						</div>
					</div> -->
		<!-- <div class="weui-cell weui-cell_active weui-cell_vcode">
						<div class="weui-cell__hd"><label class="weui-label">验证码</label></div>
						<div class="weui-cell__bd">
							<input class="weui-input" v-model="code" type="text"
								   required emptyTips="请输入验证码" placeholder="输入验证码" maxlength="6"/>
						</div>
						<div class="weui-cell__ft">
							<button class="weui-btn weui-btn_default weui-vcode-btn" @click="getCode(1)">
								{{alreadySend ?'已发送 ' + second + ' S':'获取验证码'}}</button>
						</div>
					</div> -->
		<!-- </div> -->
		<!--<div class="weui-cells__tips"><a class="weui-link" href="javascript:">收不到验证码</a></div>-->
		<!-- <div class="weui-btn-area"> -->
		<!-- <button class="weui-btn weui-btn_primary" @click="getMemberInfo">获 取 会 员 卡 信 息</button> -->
		<!-- </div> -->
		<!-- </div> -->
		<!-- </div> -->
		<article class="weui-article">
			<p>会员卡信息</p>
		</article>
		<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
			<div v-if="memberCardList.length > 0">
				<div class="weui-cells__group weui-cells__group_form">
					<div class="weui-cells weui-cells_checkbox">
						<label class="weui-cell weui-check__label carBox" :for="item.id"
							v-for="(item, index) of memberCardList" @click="handleCheckedOption(item)">
							
								<div class="weui-cell__hd">
									<input type="radio" name="radio" class="weui-check" :disabled="item.depositBalance <= 0"
										:id="item.id" />
									<i class="weui-icon-checked"></i>
								</div>
							
							
							<div class="weui-cell__bd">
								<div style="display: flex; justify-content: space-between; align-items: center">
									<span>{{item.custName}}</span>

									<div>
										<span style="font-size: 12px;">剩余</span>
										<!-- <button class="weui-btn weui-btn_mini weui-btn_default" v-if="memberCardList[index].entryInfoList && memberCardList[index].entryInfoList.length > 0"
												@click.stop="checkRecord(index)">查看记录</button> -->
									</div>
								</div>
								<div style="display: flex; justify-content: space-between; align-items: center">
									<span style="font-size: 12px;" v-if="item.type === '期间卡'">期间卡</span>
									<span style="font-size: 12px;" v-else-if="item.type === '计次卡'">计次卡</span>
									<span style="font-size: 12px;" v-else="item.type === '一卡通'">一卡通</span>
									<div>
										<span v-if="item.type === '期间卡'"> {{item.depositBalance}}天 </span>
										<span v-else-if="item.type === '计次卡'">{{item.depositBalance}}次 </span>
										<span v-else="item.type === '一卡通'"><span>{{item.depositBalance /100}}</span>元 </span>
										<!-- <button class="weui-btn weui-btn_mini weui-btn_default" v-if="memberCardList[index].entryInfoList && memberCardList[index].entryInfoList.length > 0"
												@click.stop="checkRecord(index)">查看记录</button> -->
									</div>
								</div>
							</div>
						</label>
					</div>
				</div>
			</div>
			<no-data v-else msg="暂无"></no-data>
		</cube-scroll>
		<div class="js_dialog" v-show="isClickPay">
			<div class="weui-mask"></div>
			<div class="weui-dialog" style="top: 30%">
				<div class="balanceOk">
					<div ref="telForm" class="weui-form__control-area">
						<div class="weui-cells__group weui-cells__group_form">
							<div class="weui-cells weui-cells_form">
								<div class="weui-cell weui-cell_active">
									<div class="weui-cell__hd"><label class="weui-label">手机号</label></div>
									<div class="weui-cell__bd">
										<input class="weui-input" v-model="phonenumber" type="tel" maxlength="11"
											required emptyTips="请输入手机号" placeholder="请输入手机号"/>
									</div>
								</div>
								<div class="weui-cell weui-cell_active weui-cell_vcode">
									<div class="weui-cell__hd" style="padding-right: 5px">
										<label style="width: 60px" class="weui-label">验证码</label>
									</div>
									<div class="weui-cell__bd">
										<input class="weui-input" v-model.trim="payCode" type="text"
											required emptyTips="请输入验证码" placeholder="输入验证码" maxlength="6"/>
									</div>
									<div class="weui-cell__ft">
										<button class="weui-btn weui-btn_default weui-vcode-btn" @click="getCode(2)">
											{{payAlreadySend ?'已发送 ' + paySecond + ' S':'获取验证码'}}</button>
									</div>
								</div>
							</div>
							<!--<div class="weui-cells__tips"><a class="weui-link" href="javascript:">收不到验证码</a></div>-->
						</div>
					</div>
					<div class="weui-dialog__ft">
						<a class="weui-dialog__btn weui-dialog__btn_default" @click="cancel">取消</a>
						<a class="weui-dialog__btn weui-dialog__btn_primary" @click="confirmToPay">确认支付</a>
					</div>
				</div>
				<!-- <div class="balanceNo">
					<p><a class="weui-dialog__btn weui-dialog__btn_default" @click="cancel">余额不足，请重选</a></p>
				</div> -->
			</div>
		</div>
		<!-- 
		<div class="js_dialog" v-if="isShowRecord">
			<div class="weui-mask"></div>
			<div class="weui-dialog" style="width:350px; height: 300px;top: 30%">
				<cube-scroll ref="recordScroll" class="record-cube-scroll" :options="scrollOptions">
					<div v-if="recordList.length > 0">
						<div class="weui-cells__group weui-cells__group_form">
							<div v-for="(item) of recordList" class="weui-cells weui-cells_checkbox record-item">
								<label class="weui-cell weui-check__label record-label" :for="item.tradeId">
									<div class="weui-cell__hd">
										<input type="radio" name="radio" class="weui-check" :id="item.tradeId" @click="handleCheckedRecordOption(item)"/>
										<i class="weui-icon-checked"></i>
									</div>
								</label>
								<div class="weui-cell__bd">
									<div>
										<p style="font-size: 15px">
											<span>订单号: {{item.ticketId}}</span>
											<span style="color: #06ae56;margin-left: 10px" @click.stop="checkMore(item)">{{item.isShow ? "收起": "查看更多"}}</span>
										</p>
									</div>
									<div style="font-size: 15px" v-if="item.isShow">
										<p>运动项目:{{item.serviceName}}</p>
										<p>入馆时间:{{item.enterTime}}</p>
										<p>票生效时间:{{item.ticketStartTime}}</p>
										<p>票失效时间:{{item.ticketEndTime}}</p>
									</div>

								</div>
							</div>
						</div>
					</div>
					<no-data v-else msg="暂无"></no-data>
				</cube-scroll>
				<div class="weui-dialog__ft">
					<a class="weui-dialog__btn weui-dialog__btn_default" @click="isShowRecord = false">取消</a>
					<a class="weui-dialog__btn weui-dialog__btn_primary" @click="confirmToDiscount">确认支付</a>
				</div>
			</div>
		</div> -->
		<div class="weui-btn-area">
			<button class="weui-btn weui-btn_primary" :class="!checkedeCardNo ? 'weui-btn_disabled': 'weui-btn_primary'"
				@click="handlePay" :disabled="!checkedeCardNo">支付
			</button>
		</div>
	</div>
</template>

<script>
	import { getPayCode, getCardInfo, memberPay, getDiscounts } from "api/coupon/memberOrder";
	import { pay } from "api/coupon/pay";
	import { mapGetters } from 'vuex'

	export default {
		name: "memberOrder",
		data() {
			return {
				code: undefined,
				alreadySend: false,
				second: 60,
				parkinglotId: undefined,
				plateNo: undefined,
				playMoney:undefined,
				payAlreadySend: false,
				paySecond: 60,
				payCode: undefined,
				isShowRecord: false,
				isClickPay: false,
				recordList: [],
				checkedRecordObj: {},
				discountList: [],
				memberCardList: [],
				checkedeCardNo: undefined,
				checkedeCardType: undefined,
				phonenumber: undefined,
				scrollOptions: {
					click: true,
					bounce: false
				},

			}
		},
		computed: {
			...mapGetters(['orderInfo', 'parkrec', 'areaId', 'doorId'])
		},
		created() {
			if (this.$route.params.parkinglotId) {
					this.parkinglotId = this.$route.params.parkinglotId;
				}
				if (this.$route.params.plateNo) {
					
					this.plateNo = this.$route.params.plateNo;
					this.playMoney = this.$route.params.playMoney;
					
					getCardInfo(this.parkinglotId, this.plateNo
								// code: this.code
							).then(res => {
								if (res.code === 0) {
									
									let memberCardList = res.data;
									let filterCardList = [];
									memberCardList.map(item => {
										if (item.ecardNo) {
											filterCardList.push(item)
										}
										
									});
									this.memberCardList = filterCardList
									return memberCardList
								}
							})
		
					// let form = this.$refs['form'];
					// this.$weui.form.validate(form, error => {
					// 	if (!error) {
					// 		getCardInfo(this.parkinglotId, this.plateNo
					// 			// code: this.code
					// 		).then(res => {
					// 			if (res.code === 0) {
					// 				let memberCardList = res.data;
					// 				let filterCardList = [];
					// 				memberCardList.map(item => {
					// 					if (item.ecardNo) {
					// 						filterCardList.push(item)
					// 					}
					// 				});
					// 				this.memberCardList = filterCardList
					// 			}
					// 		})
					// 	}
					// })
				}
			
		},
		methods: {
		
			blur() {
				window.scrollTo(0, 0)
			},
			/* 获取验证码按钮操作**/
			getCode(val) {
				if (val === 1) {
					if (this.alreadySend) {
						return false
					} else {
						if (this.phonenumber) {
							this.sendMsg(val)
						} else {
							this.$weui.alert('请输入手机号')
						}
					}
				} else {
					if (this.payAlreadySend) {
						return false
					} else {
						this.sendMsg(val)
					}
				}

			},
			sendMsg(val) {
				getPayCode({
					parkinglotId: this.parkinglotId,
					phone: this.phonenumber
				}).then(res => {
					if (res.code === 0) {
						if (val === 1) {
							this.alreadySend = true;
							this.timer(val);
						} else {
							this.payAlreadySend = true;
							this.timer(val);
						}
					}
				})
			},
			timer(val) {
				let promise = new Promise((resolve, reject) => {
					if (val === 1) {
						this.setTimer = setInterval(
							() => {
								this.second -= 1;
								if (this.second <= 0) {
									this.second = 60;
									this.alreadySend = false;
									resolve(this.setTimer)
								} else {
									this.alreadySend = true
								}
							}, 1000)
					} else {
						this.paySetTimer = setInterval(
							() => {
								this.paySecond -= 1;
								if (this.paySecond <= 0) {
									this.paySecond = 60;
									this.payAlreadySend = false;
									resolve(this.paySetTimer)
								} else {
									this.payAlreadySend = true
								}
							}, 1000)
					}

				});
				promise.then((setTimer) => {
					clearInterval(setTimer)
				})

			},
			// getMemberInfo() {
			// 	let form = this.$refs['form'];
			// 	this.$weui.form.validate(form, error => {
			// 		if (!error) {
			// 			getCardInfo(this.parkinglotId, this.plateNo
			// 				// code: this.code
			// 			).then(res => {
			// 				if (res.code === 0) {
			// 					let memberCardList = res.data;
			// 					let filterCardList = [];
			// 					memberCardList.map(item => {
			// 						if (item.ecardNo) {
			// 							filterCardList.push(item)
			// 						}
			// 					});
			// 					this.memberCardList = filterCardList
			// 				}
			// 			})
			// 		}
			// 	})
			// },
			//查看记录按钮操作
			checkRecord(index) {
				this.isShowRecord = true;
				this.recordList = this.memberCardList[index].entryInfoList;
				this.discountList = this.memberCardList[index].discountList;
				this.checkedRecordObj = {};
			},
			handleCheckedOption(item) {
				if (item.depositBalance <= 0) {
					this.$weui.alert('金额不足');
					
					return false;
				}else if (item.depositBalance <= this.playMoney  ) {
					this.$weui.alert('金额不足');
					this.checkedeCardNo =""
					return false;
				}else{
					this.checkedeCardNo = item.ecardNo
				}
				this.checkedeCardType = item.type
				
			},
			handleCheckedRecordOption(item) {
				this.checkedRecordObj = item;
				console.log('点击', this.checkedRecordObj.tradeId);

			},
			//查看更多按钮操作
			/*             checkMore (item) {
							console.log('展开');
							if (!item.isShow){
								this.$set(item,'isShow',true);
							} else {
								this.$set(item,'isShow',false);
							}
			
						}, */
			//健身记录确认支付按钮操作
			/* confirmToDiscount () {
				if (!this.checkedRecordObj.tradeId) {
					this.$weui.alert('请选择');
					return
				}
				let data = {
					enterTime: this.checkedRecordObj.enterTime,
					phone: this.phonenumber,
					orderSn: this.orderInfo.orderSn,
					tradeId: this.checkedRecordObj.tradeId,
					discountList: this.discountList
				};
				getDiscounts(data).then(res =>{
					if (res.code === 200){
						this.isShowRecord = false;
						if (res.data && res.data.unpaidMoney){
							this.$api.order
								.pay({
									orderSn: this.orderInfo.orderSn,
									parkinglotId: this.parkinglotId,
									totalAmount: parseFloat(res.data.unpaidMoney).toFixed(2),
									areaId: this.areaId,
									payType: this.checkBrowser.id,
									openId: localStorage.getItem('userOpenId')
								}).then(res =>{
								if (res.data.code == 200) {
									this.$pay(res.data)
								} else {
									this.$createDialog({
										type: "confirm",
										icon: "cubeic-alert",
										title: "提示",
										content: res.data.msg,
										confirmBtn: {
											text: "确定",
											active: true,
											disabled: false,
											href: "javascript:;"
										},
										cancelBtn: {
											text: "取消",
											active: false,
											disabled: false,
											href: "javascript:;"
										},
										onConfirm: () => {
											var parkinglotId = this.$encryptUtil.encrypt(this.parkinglotId);
											var doorId = this.$encryptUtil.encrypt(this.doorId);
											this.$router.replace({
												path: "/scan",
												query: {parkinglotId: parkinglotId, doorId: doorId}
											});
										},
										onCancel: () => {
										}
									}).show();
								}
							})
						} else if (res.data && res.data.unpaidMoney <= 0) {
							this.$weui.alert('支付成功')
						}
					}
				})

			}, */
			handlePay(tem) {
				this.isClickPay = true;
				
			},
			confirmToPay() {
				if (!this.payCode) {
					this.$weui.alert('请输入验证码')
				} else {
					memberPay({
						parkinglotId: this.parkinglotId,
						realPay: Number(this.orderInfo.totalPrice) * 100,
						ecardNo: this.checkedeCardNo,
						code: this.payCode,
						tradeId: this.orderInfo.id,
						type: this.checkedeCardType,
						orderSn: this.orderInfo.orderSn
					}).then(res => {
						console.log(res);
						if (res.code === 0) {
							this.$weui.alert('支付成功，如需查看会员卡余额请重新获取验证码查询');
							this.isClickPay = false;
							clearInterval(this.setTimer);
							clearInterval(this.paySetTimer);
							this.payAlreadySend = false;
							this.paySecond = 60;
							this.alreadySend = false;
							this.second = 60;
						}
					})
				}
			},
			cancel() {
				clearInterval(this.paySetTimer);
				this.payAlreadySend = false;
				this.paySecond = 60;
				this.isClickPay = false
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import "../../common/stylus/variable.styl"
	.single-page-wrap {
		padding-top 10px
		.weui-form__control-area{
			margin 5px 0
		}
		.weui-cells {
			.weui-cell {
				padding 15px
			}
		}
		.weui-cells:before {
			display none
		}
		.weui-btn-area {
			margin-top 20px
			.weui-btn {
				width: 100%;
			}
			p {
				font-size $article-p
				color $article-merchant-p
				line-height 20px
				padding-top 10px
			}
		}
		.weui-article {
			padding-bottom 5px
			p {
				margin-bottom 0
			}
		}
		.cube-scroll {
			position: relative;
			text-align: left;
			white-space: normal;
			max-height: 50%
			overflow hidden
			background: #ffffff;
			border 1px solid #e6e6e6
			.weui-form__control-area {
				margin-top 0
			}
			.weui-cells:before {
				border-top none
			}
			.weui-cells__group_form .weui-cell {
				padding: 10px;
				margin :10px;
				background: #5495f6;
    			border-radius:10px;
				color:#fff;
			}
		}
		.record-cube-scroll{
			position: relative;
			text-align: left;
			white-space: normal;
			max-height: 280px
			overflow hidden
			background: #ffffff;
			border 1px solid #e6e6e6
			.weui-cells__group_form .record-label {
				padding 8px 0 8px 16px

			}
			.weui-cells__group_form .record-item {
				padding-bottom 8px
				display flex
				align-items center
			}
		}
		.weui-dialog {
			.weui-cells_form {
				padding 10px 0
			}
			.weui-cells:before {
				border none
			}
			.weui-cells:after {
				border none
			}
		}

	}
	.weui-hidden_abs button.weui-hidden_abs{
		display: none
	}

</style>